module.exports = __webpack_public_path__ + "img/users-logo-active.8143b9a3.svg";